import isFeatureToggleOn from "@javascripts/utils/feature_toggle";
import '@javascripts/advertisements/lottie_loader'
import '@javascripts/advertisements/ads_transition'

export default class TvcReplacement {
  constructor({ tech, threshold, adTag }) {
    this._hasBeenSetup = false
    this._tech = tech
    this._threshold = threshold
    this._adTag = adTag
  }

  get tech() {
    return this._tech
  }

  get threshold() {
    return this._threshold
  }

  get adTag() {
    return this._adTag
  }

  start(timestamp) {
    if (!this._hasBeenSetup) return;

    this._cueInTimestamp = timestamp;
    this._startTimestamp = this.tech.currentTime();
    this._startTime = new Date();

    this.adsTransition().show()
    this.adsTransition().fadeIn()
      .then(() => {
        this.displayAds()
      })
      .catch(e => console.log(e))
  }

  setup() {
    if (this._hasBeenSetup) return;
    if (!this.isImaObjectDefined()) return

    this.setupEvents();
    this._hasBeenSetup = true;
  }

  setupEvents() {
    this.tech.on('adserror', this.onAdError.bind(this));
    this.tech.on('ads-manager', () => {
      this.setupEventOnSeeked();
      this.setupEventOnAdCompleted();
      this.setupEventOnAdProgress();
    });
  }

  setCueOutTimestamp(timestamp) {
    this._cueOutTimestamp = timestamp
  }

  resumeContent() {
    const advanceTime = this._startTimestamp + this.calculateElapsedTimeFrom(this._startTime);
    this.advancePlayer(advanceTime);
    this.resetTimestamp();
    this.lottieLoader().hide()
    this.adsTransition().fadeOut()
    this.tech.play()
  }

  onAdError() {
    this.resumeContent()
  }

  resetTimestamp() {
    this._cueInTimestamp = undefined;
    this._startTime = undefined;
    this._startTimestamp = undefined;
    this._cueOutTimestamp = undefined
  }

  setupEventOnSeeked() {
    this.tech.on('seeked', () => {
      this.tech.play();
    });
  }

  setupEventOnAdCompleted() {
    this.ima().addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this.onCompleted.bind(this));
  }

  onCompleted(e) {
    const adPod = e?.getAd().getAdPodInfo()
    
    if (this.isLoadMoreDisabled() || this.shouldStop() || this.isAdPodEmpty(adPod)) {
      this.resumeContent();
      return;
    }

    this.displayAds();
  }

  setupEventOnAdProgress() {
    this.ima().addEventListener(google.ima.AdEvent.Type.AD_PROGRESS, this.onAdProgress.bind(this));
  }

  onAdProgress() {
    if (this.shouldStop()) {
      this.ima().getAdsManager().stop()
    }
  }

  calculateElapsedTimeFrom(time) {
    return (new Date() - time) / 1000; // seconds
  }

  shouldStop() {
    return this.hasReachedCueOut() || this.hasReachedThreshold();
  }

  isAdPodEmpty(adPod) {
    return typeof adPod.data === 'undefined' || adPod.getTotalAds() === 0
  }

  hasReachedThreshold() {
    return this.calculateElapsedTimeFrom(this._startTime) >= this.threshold;
  }

  isLoadMoreDisabled() {
    return isFeatureToggleOn("turn_off_load_more_tvc_replacement");
  }

  hasReachedCueOut() {
    if(this._cueOutTimestamp == null) {
      return false
    }

    const timestampDifferenceInSecond = (this._cueOutTimestamp - this._cueInTimestamp) / 1000

    return this.calculateElapsedTimeFrom(this._startTime) >= timestampDifferenceInSecond
  }

  displayAds() {
    this.replaceAdTag();
    this.lottieLoader().show()
    this.requestAds();
  }

  replaceAdTag() {
    if (!this.adTag) {
      return;
    }
    typeof this.ima().changeAdTag === 'function' && this.ima().changeAdTag(this.adTag);
  }

  requestAds(){
    typeof this.ima().requestAds === 'function' && this.ima().requestAds();
  }

  ima(){
    return this.tech.plugin().imaObject();
  }

  advancePlayer(timestamp) {
    this.tech.currentTime(timestamp);
  }

  lottieLoader() {
    return this.tech.plugin().instance().getChild('LottieLoader')
  }

  adsTransition() {
    return this.tech.plugin().instance().getChild('AdsTransition')
  }

  isImaObjectDefined() {
    return typeof this.ima() === 'object'
  }
}
